

























import { computed, defineComponent, reactive } from '@vue/composition-api';
import { useQuery } from '@vue/apollo-composable';

import averageDeliveryTimeByHub from '@/gql/managementReport/04-DeliveryTime/averageDeliveryTimeByHub.gql';

import { NOW_YEAR } from '@/utils';
import {
  deliveryTimeColor,
  deliveryTimeColorHue,
} from '@/useDelivery';

import ChartWithMoneyAxis from '@/components/Vivat/Chart/ChartWithMoneyAxis.vue';
import { printIntrospectionSchema } from 'graphql';

const AverageDeliveryTimeByHub = defineComponent({
  components: {
    ChartWithMoneyAxis,
  },
  props: {
    primaryColor: {
      type: String,
      default: 'rgba(18,74,136,255)',
    },
    height: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const filter = reactive({
      monthRange: {
        from: `${NOW_YEAR}-01-01`,
        to: `${NOW_YEAR}-12-31`,
      },
    });
    const toCommaFormat = (val: number, min = 0, max = 0) => val.toLocaleString('th-TH', { minimumFractionDigits: min, maximumFractionDigits: max });

    const { result, loading } = useQuery(averageDeliveryTimeByHub, computed(() => ({
      timeframe: filter.monthRange,
    })));

    const getDataArray = computed(() => {
      if (loading.value === false) {
        return result.value.averageDeliveryTimeByHub || { duration: [], hubDuration: [] };
      }
      return {
        duration: [],
        hubDuration: [],
      };
    });

    const labels = computed(() => ({
      duration: getDataArray.value.duration?.map((item: any) => item.hub) || [],
      hubDuration: getDataArray.value.hubDuration?.map((item: any) => item.hub) || [],
    }));
    const data = computed(() => ({
      duration: getDataArray.value?.duration?.map((item: any) => toCommaFormat(item.amount, 1, 1)) || [],
      hubDuration: getDataArray.value?.hubDuration?.map((item: any) => toCommaFormat(item.amount, 1, 1)) || [],
    }));

    const plugins = {
      legend: {
        display: false,
      },
    };
    const chartData = computed(() => ({
      labels: labels.value.duration,
      datasets: [
        {
          label: 'ระยะเวลาส่งถึงศูนย์กระจายสินค้า',
          data: data.value.hubDuration,
          stack: 'CURRENT',
          maxBarThickness: 80,
          backgroundColor: getComputedStyle(document.documentElement).getPropertyValue('--color-primary-300'),
          // backgroundColor: (ctx: any) => {
          //   const index = ctx.dataIndex;
          //   const value = ctx.dataset.data[index];

          //   if (typeof value === 'number' || typeof value === 'string') {
          //     const roundedValue = Math.ceil(value as number);
          //     const colorKey = `day${roundedValue}` as keyof typeof deliveryTimeColorHue;
          //     if (roundedValue > 7) return deliveryTimeColorHue.day7;
          //     if (roundedValue > 3) return deliveryTimeColorHue.day4;
          //     if (colorKey in deliveryTimeColorHue) {
          //       return deliveryTimeColorHue[colorKey];
          //     }
          //     return props.primaryColor;
          //   }
          //   return props.primaryColor;
          // },
        },
        {
          label: 'ระยะเวลาส่งถึงปลายทาง',
          data: data.value.duration,
          stack: 'CURRENT',
          maxBarThickness: 80,
          backgroundColor: getComputedStyle(document.documentElement).getPropertyValue('--color-primary-500'),
          // backgroundColor: (ctx: any) => {
          //   const index = ctx.dataIndex;
          //   const value = ctx.dataset.data[index];

          //   if (typeof value === 'number' || typeof value === 'string') {
          //     const roundedValue = Math.ceil(value as number);
          //     const colorKey = `day${roundedValue}` as keyof typeof deliveryTimeColor;
          //     if (roundedValue > 7) return deliveryTimeColor.day7;
          //     if (roundedValue > 3) return deliveryTimeColor.day4;
          //     if (colorKey in deliveryTimeColor) {
          //       return deliveryTimeColor[colorKey];
          //     }
          //     return props.primaryColor;
          //   }
          //   return props.primaryColor;
          // },
        },
      ],
    }));

    const computedMaxYScale = computed(() => {
      const allData = data.value.duration.map((d: string, index: number) => parseFloat(d) + parseFloat(data.value.hubDuration[index]));
      const max = Math.max(...allData) + 0.05;
      if (!Number.isInteger(max)) {
        if (max < 1) {
          return 1;
        }
        if (max < 10) {
          return Math.ceil(max + (max * (15 / 100)));
        }
        if (max < 100) {
          return Math.ceil(max / 10) * 10;
        }
        if (max < 1000) {
          return Math.ceil(max / 100) * 100;
        }
        return Math.ceil(max + (max * (10 / 100)));
      }
      return Math.ceil(max + (max * (15 / 100))); // +15% clearance from top (y axis)
    });

    return {
      filter,
      plugins,
      averageDeliveryTimeByHub,
      computedMaxYScale,
      chartData,
    };
  },
});

export default AverageDeliveryTimeByHub;
